/* Store behaviour: buy-now buttons, photo lightbox, review filters, product countdown, sticky buy bar. */
(function () {
  'use strict';
  if (window.__afHomeInit) return;
  window.__afHomeInit = true;

  var routes = window.routes || {};
  var CART_ADD = routes.cart_add_url || '/cart/add';
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function jsonUrl(u) { return u.indexOf('.js') === -1 ? u + '.js' : u; }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', !!on);
    btn.setAttribute('aria-busy', on ? 'true' : 'false');
  }

  // Restore usable purchase controls when Back restores the page from browser cache.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll('[data-af-buy]').forEach(function (btn) {
      setLoading(btn, false);
    });
  });

  function scopeOf(btn) {
    return (btn && btn.closest('[data-af-scope]')) || document;
  }

  function showError(btn, msg) {
    var scope = scopeOf(btn);
    var box = scope.querySelector ? scope.querySelector('[data-af-error]') : null;
    if (!box) { window.alert(msg); return; }
    box.textContent = msg;
    box.hidden = false;
  }

  function errorText(btn, fallback) {
    var scope = btn && btn.closest('[data-af-scope]');
    return (scope && scope.getAttribute('data-af-error-msg')) || fallback;
  }

  var BASE = ROOT.replace(/\/$/, '');
  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function cartIds() {
    return fetch(BASE + '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return (c.items || []).map(function (i) { return String(i.variant_id); }); })
      .catch(function () { return []; });
  }

  function cartHas(variantId) {
    return cartIds().then(function (ids) { return ids.indexOf(String(variantId)) !== -1; });
  }

  // Include selected bonuses in Shopify's accelerated product checkout too.
  function syncBonusCheckout() {
    document.querySelectorAll('.product__info-container').forEach(function (scope) {
      var form = scope.querySelector('form[data-type="add-to-cart-form"]');
      if (!form) return;
      form.querySelectorAll('[data-af-checkout-bonus]').forEach(function (input) { input.remove(); });
      scope.querySelectorAll('[data-af-freebie]:checked').forEach(function (checkbox, index) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'shopify-additional-items[' + (index + 1) + '][id]';
        input.value = checkbox.getAttribute('data-variant-id');
        input.setAttribute('data-af-checkout-bonus', '');
        form.appendChild(input);
      });
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-af-freebie]')) syncBonusCheckout();
  });
  window.addEventListener('pageshow', syncBonusCheckout);

  function freebieIds() {
    return Array.prototype.map.call(document.querySelectorAll('[data-af-freebie]:checked'), function (el) {
      return String(el.getAttribute('data-variant-id'));
    });
  }

  // Adds the book plus any ticked free guides, skipping whatever is already in the cart.
  function addWithFreebies(variantId) {
    return cartIds().then(function (inCart) {
      // Add bonuses before the main book so Shopify displays the main book first.
      var want = freebieIds().concat([String(variantId)]);
      var items = want.filter(function (id, i) { return id && want.indexOf(id) === i && inCart.indexOf(id) === -1; })
        .map(function (id) { return { id: parseInt(id, 10), quantity: 1 }; });
      if (!items.length) return null;
      return fetch(jsonUrl(CART_ADD), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'error');
          return res.data;
        });
    });
  }

  function addToCart(variantId) {
    return fetch(jsonUrl(CART_ADD), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'error');
        return res.data;
      });
  }

  function refreshCartBubble() {
    return fetch(BASE + '/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var html = sections && sections['cart-icon-bubble'];
        var el = document.getElementById('cart-icon-bubble');
        if (!html || !el) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var inner = tmp.querySelector('.shopify-section') || tmp;
        el.innerHTML = inner.innerHTML;
        el.classList.remove('af-bump');
        void el.offsetWidth;
        el.classList.add('af-bump');
      })
      .catch(function () { /* the count updates on the next page load */ });
  }

  function flyToCart() {
    var img = document.querySelector('[id^="MainProduct-"] .product__media img, .product__media img');
    var cart = document.getElementById('cart-icon-bubble');
    if (REDUCE || !img || !cart || !img.animate) return Promise.resolve();
    var a = img.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > window.innerHeight) return Promise.resolve();
    var b = cart.getBoundingClientRect();
    var tx = b.bottom > 0 ? b.left + b.width / 2 : window.innerWidth - 40;
    var ty = b.bottom > 0 ? b.top + b.height / 2 : 24;
    var clone = document.createElement('img');
    clone.src = img.currentSrc || img.src;
    clone.alt = '';
    clone.className = 'af-fly';
    clone.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
    document.body.appendChild(clone);
    var dx = tx - (a.left + a.width / 2), dy = ty - (a.top + a.height / 2);
    var anim = clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1 },
      { transform: 'translate(' + dx * 0.5 + 'px,' + (dy * 0.5 - 60) + 'px) scale(.45)', opacity: .9, offset: .55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.06)', opacity: .3 }
    ], { duration: 800, easing: 'cubic-bezier(.45,0,.2,1)' });
    return anim.finished.then(function () { clone.remove(); }, function () { clone.remove(); });
  }

  function buyNow(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id) {
      showError(btn, errorText(btn, 'Last inn siden på nytt og prøv igjen.'));
      return;
    }
    setLoading(btn, true);
    addWithFreebies(id)
      .then(function () { window.location.href = BASE + '/checkout'; })
      .catch(function () {
        setLoading(btn, false);
        showError(btn, errorText(btn, 'Kunne ikke legge produktet i handlekurven. Prøv igjen.'));
      });
  }

  function initAddCart(root) {
    var btn = root.querySelector('[data-af-atc-btn]');
    var panel = root.querySelector('[data-af-added]');
    var id = root.getAttribute('data-variant-id');
    var cartUrl = root.getAttribute('data-cart-url') || '/cart';
    if (!btn || !id) return;
    if (panel && panel.parentNode !== document.body) document.body.appendChild(panel);
    var closeTimer = null;
    function setState(st) {
      btn.setAttribute('data-state', st);
      btn.setAttribute('aria-busy', st === 'busy' ? 'true' : 'false');
      var sr = btn.querySelector('.af-atc__label--' + st + ' .af-atc__sr');
      if (sr) { btn.setAttribute('aria-label', sr.textContent); btn.setAttribute('data-tip', sr.textContent); }
    }
    setState(btn.getAttribute('data-state') || 'idle');
    function closePanel() {
      if (!panel) return;
      clearTimeout(closeTimer);
      panel.classList.remove('is-open');
      setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 350);
    }
    function openPanel() {
      if (!panel) return;
      panel.hidden = false;
      panel.classList.remove('is-timing');
      void panel.offsetWidth;
      panel.classList.add('is-open', 'is-timing');
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closePanel, 9000);
    }
    if (panel) {
      panel.querySelector('[data-af-added-close]').addEventListener('click', closePanel);
      panel.addEventListener('mouseenter', function () { clearTimeout(closeTimer); panel.classList.add('is-paused'); });
      panel.addEventListener('mouseleave', function () { panel.classList.remove('is-paused'); closeTimer = setTimeout(closePanel, 4000); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && panel.classList.contains('is-open')) closePanel(); });
    }
    cartHas(id).then(function (has) { if (has) setState('incart'); });
    btn.addEventListener('click', function () {
      var st = btn.getAttribute('data-state');
      if (st === 'busy' || st === 'done') return;
      if (st === 'incart') { window.location.href = cartUrl; return; }
      setState('busy');
      addWithFreebies(id)
        .then(function () {
          setState('done');
          return Promise.all([flyToCart(), refreshCartBubble()]);
        })
        .then(function () {
          openPanel();
          setTimeout(function () { setState('incart'); }, 1800);
        })
        .catch(function () {
          setState('idle');
          showError(btn, errorText(btn, 'Kunne ikke legge produktet i handlekurven. Prøv igjen.'));
        });
    });
  }

  function quickAdd(btn) {
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-added')) return;
    btn.classList.add('is-busy');
    cartHas(id)
      .then(function (has) { return has ? null : addToCart(id); })
      .then(function () {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        btn.textContent = '\u2713';
        return refreshCartBubble();
      })
      .catch(function () { btn.classList.remove('is-busy'); });
  }

  function initGallery(root) {
    var strip = root.querySelector('[data-af-strip]');
    var prev = root.querySelector('[data-af-strip-prev]');
    var next = root.querySelector('[data-af-strip-next]');
    if (strip && prev && next) {
      var step = function () { return Math.max(200, strip.clientWidth * 0.8); };
      var sync = function () {
        prev.disabled = strip.scrollLeft <= 2;
        next.disabled = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 2;
      };
      prev.addEventListener('click', function () { strip.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { strip.scrollBy({ left: step(), behavior: 'smooth' }); });
      strip.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync);
      sync();
    }
    var dlg = root.querySelector('[data-af-lightbox]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-af-lightbox-src]'));
    if (!btns.length) return;
    var img = dlg.querySelector('.af-lightbox__img');
    var cap = dlg.querySelector('.af-lightbox__cap');
    var idx = 0;
    function show(i) {
      idx = (i + btns.length) % btns.length;
      var b = btns[idx];
      var c = b.getAttribute('data-af-lightbox-caption') || '';
      img.src = b.getAttribute('data-af-lightbox-src');
      img.alt = c;
      cap.textContent = c;
      cap.hidden = !c;
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { show(i); dlg.showModal(); });
    });
    dlg.querySelector('[data-af-lightbox-close]').addEventListener('click', function () { dlg.close(); });
    dlg.querySelector('[data-af-lightbox-prev]').addEventListener('click', function () { show(idx - 1); });
    dlg.querySelector('[data-af-lightbox-next]').addEventListener('click', function () { show(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    dlg.addEventListener('close', function () { img.removeAttribute('src'); });
  }

  function initReviews(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-af-review]'));
    var list0 = root.querySelector('.af-reviews__list');
    items.sort(function (a, b) { return (parseFloat(a.getAttribute('data-position')) || 0) - (parseFloat(b.getAttribute('data-position')) || 0); });
    if (list0) items.forEach(function (it) { list0.appendChild(it); });
    var more = root.querySelector('[data-af-more]');
    var empty = root.querySelector('[data-af-empty]');
    var status = root.querySelector('[data-af-status]');
    var statusText = root.getAttribute('data-af-status-text') || '';
    var showAll = root.getAttribute('data-af-show-all') || '';
    var pageSize = parseInt(root.getAttribute('data-af-page-size'), 10) || 6;
    var state = { filter: 'all', shown: pageSize };
    function render() {
      var matched = items.filter(function (it) {
        return state.filter === 'all' || it.getAttribute('data-rating') === state.filter;
      });
      items.forEach(function (it) { it.hidden = true; });
      matched.slice(0, state.shown).forEach(function (it) { it.hidden = false; });
      if (more) more.hidden = matched.length <= state.shown;
      if (empty) empty.hidden = matched.length > 0;
      Array.prototype.forEach.call(root.querySelectorAll('[data-af-filter]'), function (b) {
        var on = b.getAttribute('data-af-filter') === state.filter;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (status) {
        if (state.filter === 'all') { status.hidden = true; status.textContent = ''; }
        else {
          status.textContent = statusText.replace('[count]', matched.length).replace('[stars]', state.filter) + ' ';
          var reset = document.createElement('button');
          reset.type = 'button';
          reset.className = 'af-reviews__reset';
          reset.setAttribute('data-af-filter', 'all');
          reset.textContent = showAll;
          status.appendChild(reset);
          status.hidden = false;
        }
      }
    }
    root.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-af-filter]');
      if (!b || !root.contains(b)) return;
      state.filter = b.getAttribute('data-af-filter');
      state.shown = pageSize;
      render();
      var list = root.querySelector('.af-reviews__list');
      if (list && b.closest('.af-reviews__hist')) list.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    if (more) more.addEventListener('click', function () { state.shown += pageSize; render(); });
    render();
  }

  function initCountdown(el) {
    var hours = parseFloat(el.getAttribute('data-af-hours')) || 24;
    var key = 'af_cd_' + (el.getAttribute('data-af-key') || 'default');
    var total = hours * 3600 * 1000;
    var timeEl = el.querySelector('[data-af-cd-time]');
    var bar = el.querySelector('[data-af-cd-bar]');
    var end = 0;
    try { end = parseInt(localStorage.getItem(key), 10) || 0; } catch (e) { end = 0; }
    function reset() {
      end = Date.now() + total;
      try { localStorage.setItem(key, String(end)); } catch (e) { /* storage unavailable */ }
    }
    if (!end || end <= Date.now() || end - Date.now() > total) reset();
    function pad(n) { return (n < 10 ? '0' : '') + n; }
    function tick() {
      var left = end - Date.now();
      if (left <= 0) { reset(); left = total; }
      var s = Math.floor(left / 1000);
      var m = Math.floor(s / 60), sec = s % 60;
      if (timeEl) timeEl.textContent = pad(m) + ':' + pad(sec);
      if (bar) bar.style.width = Math.max(2, Math.round((left / total) * 100)) + '%';
    }
    tick();
    setInterval(tick, 1000);
  }

  function initSticky(bar) {
    // Dawn's slide-in animation leaves a transform on the product column, which would trap a fixed bar inside it.
    if (bar.parentNode !== document.body) document.body.appendChild(bar);
    var sel = bar.getAttribute('data-af-sticky-target');
    var target = sel ? document.querySelector(sel) : null;
    var depth = parseFloat(bar.getAttribute('data-af-sticky-depth'));
    if (isNaN(depth)) depth = 0;
    var targetVisible = false;
    var ticking = false;
    function update() {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var progress = max > 0 ? window.scrollY / max : 1;
      bar.classList.toggle('is-visible', progress >= depth && !targetVisible);
    }
    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        targetVisible = entries[0].isIntersecting;
        update();
      }, { threshold: 0 }).observe(target);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initQuotes(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('.af-quote'));
    if (slides.length < 2) return;
    var dotsBox = root.querySelector('[data-af-quotes-dots]');
    var prev = root.querySelector('[data-af-quotes-prev]');
    var next = root.querySelector('[data-af-quotes-next]');
    var interval = parseInt(root.getAttribute('data-af-interval'), 10) || 5000;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var i = 0, timer = null;
    var dots = slides.map(function (_, k) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'af-quotes__dot';
      b.setAttribute('aria-label', (k + 1) + ' / ' + slides.length);
      b.addEventListener('click', function () { go(k); restart(); });
      if (dotsBox) dotsBox.appendChild(b);
      return b;
    });
    function go(k) {
      i = (k + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === i); s.setAttribute('aria-hidden', n === i ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (reduce) return; stop(); timer = setInterval(function () { go(i + 1); }, interval); }
    function restart() { stop(); start(); }
    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    go(0);
    start();
  }

  function initVideoCircles(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll('[data-af-vc-src]')).filter(function (b) {
      return b.getAttribute('data-af-vc-src');
    });
    var list = root.querySelector('[data-af-vc-list]');
    var arrows = Array.prototype.slice.call(root.querySelectorAll('[data-af-vc-scroll]'));
    function syncArrows() {
      if (!list) return;
      var overflow = list.scrollWidth > list.clientWidth + 4;
      arrows.forEach(function (a) {
        a.hidden = !overflow;
        var dir = parseInt(a.getAttribute('data-af-vc-scroll'), 10);
        a.disabled = dir < 0 ? list.scrollLeft <= 2 : list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
      });
    }
    arrows.forEach(function (a) {
      a.addEventListener('click', function () {
        list.scrollBy({ left: parseInt(a.getAttribute('data-af-vc-scroll'), 10) * list.clientWidth * 0.7, behavior: 'smooth' });
      });
    });
    if (list) { list.addEventListener('scroll', syncArrows, { passive: true }); window.addEventListener('resize', syncArrows); syncArrows(); }

    var dlg = root.querySelector('[data-af-vc-modal]');
    if (!dlg || typeof dlg.showModal !== 'function' || !btns.length) return;
    var video = dlg.querySelector('video');
    var cap = dlg.querySelector('.af-vc-modal__cap');
    var prev = dlg.querySelector('[data-af-vc-prev]');
    var next = dlg.querySelector('[data-af-vc-next]');
    var idx = 0;
    prev.hidden = next.hidden = btns.length < 2;
    function show(i) {
      idx = (i + btns.length) % btns.length;
      var b = btns[idx];
      var c = b.getAttribute('data-af-vc-caption') || '';
      video.pause();
      video.poster = b.getAttribute('data-af-vc-poster') || '';
      video.src = b.getAttribute('data-af-vc-src');
      cap.textContent = c;
      cap.hidden = !c;
      var p = video.play();
      if (p && p.catch) p.catch(function () { /* autoplay refused: controls stay available */ });
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { dlg.showModal(); show(i); });
    });
    dlg.querySelector('[data-af-vc-close]').addEventListener('click', function () { dlg.close(); });
    prev.addEventListener('click', function () { show(idx - 1); });
    next.addEventListener('click', function () { show(idx + 1); });
    video.addEventListener('ended', function () { if (btns.length > 1) show(idx + 1); });
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
    dlg.addEventListener('close', function () { video.pause(); video.removeAttribute('src'); video.load(); });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    syncBonusCheckout();
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('[data-af-buy]');
      if (btn) { ev.preventDefault(); buyNow(btn); return; }
      var qa = ev.target.closest('[data-af-quick-add]');
      if (qa) { ev.preventDefault(); quickAdd(qa); }
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-gallery]'), initGallery);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-reviews]'), initReviews);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-countdown]'), initCountdown);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-sticky]'), initSticky);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-quotes]'), initQuotes);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-vc]'), initVideoCircles);
    Array.prototype.forEach.call(document.querySelectorAll('[data-af-atc]'), initAddCart);
    // Re-init when the theme editor re-renders a section
    document.addEventListener('shopify:section:load', function (ev) {
      syncBonusCheckout();
      Array.prototype.forEach.call(ev.target.querySelectorAll('[data-af-gallery]'), initGallery);
      Array.prototype.forEach.call(ev.target.querySelectorAll('[data-af-reviews]'), initReviews);
    });
  });
})();
